import { styled } from "@material-ui/core/styles";
import { Table } from "@material-ui/core";

import theme from "../../constants/theme";

export default styled(Table)({
  backgroundColor: "#fff",
  borderRadius: 4,
  width: "100%",
  overflowX: "auto",
  [theme.breakpoints.only("xs")]: {
    display: "block",
  },
});
